module.exports = __webpack_public_path__ + "img/page.cf4a24c7.png";